// eslint-disable-next-line no-restricted-imports
import { zonedTimeToUtc } from 'date-fns-tz';

/**
 * Wrapper around date-fns-tz zonedTimeToUtc that returns null instead of throwing
 * when date parsing fails (e.g. invalid time value, browser Intl/Date quirks like Edge on Windows 10).
 * Use this instead of zonedTimeToUtc to avoid RangeError crashes.
 */
export function parseZonedTimeToUtc(
  date: Date | string | number,
  timeZone: string
): Date | null {
  try {
    return zonedTimeToUtc(date, timeZone);
  } catch {
    return null;
  }
}
